module.exports = __webpack_public_path__ + "2a545a374ae79274b018cfeb9d2c32f4.svg";